<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'CitySelectorView'
}
</script>

<style scoped lang="stylus">
</style>
